export const setFooter = (footer = {}) => ({
  type: 'SET_FOOTER_DATA',
  data: footer
})